import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CookieService } from 'ngx-cookie-service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageService, PermissionToolkitService } from "front-common-toolkits";
import { en_US, NzI18nService, zh_CN } from "ng-zorro-antd/i18n";
import { TranslateService } from "@ngx-translate/core";
import { AuthenticationService } from "../../services/utils/authentication.service";
import * as CryptoJS from 'crypto-js';
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { SiteService } from "../../services/site.service";
import { environment } from "../../../environments/environment";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/services/state/app.state";
import * as RoleLoadedActions from "src/app/services/state/actions/roleLoaded.action";
import * as UserActions from "src/app/services/state/actions/user.action";
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, ParamMap } from '@angular/router';


// declare global {
//   interface Window {
//     WxLogin: Function;
//   }
// }

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [AuthenticationService, StorageService, CookieService]
})

export class LoginComponent implements OnInit {
  @ViewChild('tenantListContent') tenantListContent;
  product = environment.product;
  tenantSelectionModal: NzModalRef;
  validateForm: FormGroup;
  tenantLoginForm: FormGroup;
  pwdLoginForm: FormGroup;
  model: any = {};
  tenantUser: any = {};
  loading = false;
  error = '';
  loginType = environment.isAdmin ? 'admin' : 'tenant';
  isSmsCodeSent = false;
  hintMessage;
  countDownNum: number = 60;
  tenantList;
  tenantLoginResult;

  tabSelectIndex: number = 0;

  loginStatus:string = "";

  browserTips;  //浏览器版本弹窗
  isWindows;   //当前用户操作系统
  isLowBrowserVersion = false;  //是否低版本浏览器
  userPhone; //当前用户手机
  userPassword; //添加密码
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private permissionToolkitService: PermissionToolkitService,
    private siteService: SiteService,
    private notification: NzNotificationService,
    private modalService: NzModalService,
    private storageService: StorageService,
    private cookieService: CookieService,
    private translateService: TranslateService,
    private nzI18nService: NzI18nService,
    private fb: FormBuilder,
    private store: Store<AppState>,
    private sanitizer: DomSanitizer,
    private modalservice:NzModalService,
    private route: ActivatedRoute
  ) {

    let defaultLang = 'zh';
    let local = zh_CN;
    if (localStorage.getItem('defaultLang')) {
      defaultLang = localStorage.getItem('defaultLang');
    }

    store.select("user").subscribe(o => {
      console.log("user111111",o);
      this.userPhone = o.userMobile;
      this.loginStatus = o.status;
    })

    /* --- set i18n begin ---*/
    this.translateService.addLangs(['zh', 'en', 'ja']);
    this.translateService.setDefaultLang(defaultLang);
    // const browserLang = this.translateService.getBrowserLang();
    this.translateService.use(defaultLang);

    switch (defaultLang) {
      case 'en': { local = en_US; break; }
      case 'zh': { local = zh_CN; break; }
      // case 'ja': { local = ja_JP; break; }
      default: local = en_US;
    }
    this.nzI18nService.setLocale(local);
    /* --- set i18n end ---*/
    this.storageService.removeLocalItem('currentTenant');

    const tenantLoginResult = this.storageService.getItem('tenantLoginResult');
    if (tenantLoginResult) {
      this.tenantLoginResult = tenantLoginResult;
      this.tenantList = tenantLoginResult.tenantList;
    }

    this.validateForm = this.fb.group({
      username: [null, [Validators.required]],
      password: [null, [Validators.required]],
    });
    this.tenantLoginForm = this.fb.group({
      mobile: [null, [Validators.required]],
      password: [null],
      smsCode: [null, [Validators.required]]
    });
    this.pwdLoginForm = this.fb.group({
      mobile: [null, [Validators.required]],
      pwd: [null, Validators.required]
    });
  }

  ngOnInit() {
    //清空权限状态
    this.store.dispatch(new RoleLoadedActions.SetRoleLoaded(false))
    //pc端在操作过程中报“令牌过期，重新登录”后，跳转到登录页面，操作页面的层未关闭
    this.modalservice.closeAll()
    //判断当前浏览器
    this.checkCurrentBrowser()
  }
  async getUserInfo(){
    console.log(111111111)
    const result:any = await this.authenticationService.getUserInfo().toPromise()
    console.log('info',result)
  }
  login() {
    if (!this.validateForm.valid) {
      this.error = '用户名或密码错误';
      return;
    }
    this.loading = true;
    this.error = undefined;
    const pwd = CryptoJS.SHA256(this.model.password).toString();
    // const pwd = this.model.password;
    this.authenticationService.login(this.model.username, pwd.toString())
      .subscribe(async user => {

        if (user) {
          this.loading = false;

           this.router.navigate(['/admin/tenant-account']);

        } else {
          this.error = '用户名或密码错误';
          this.loading = false;
        }
      }, err => {
        this.loading = false;
        // this.error = err.error;
      });
  }

  @ViewChild('addUserPassword') addUserPassword;
  @ViewChild('addUserPasswordFooter') addUserPasswordFooter;

  addPasswordModal; //添加密码弹窗
  tenantLogin() {
    let param: any = {};
    if (this.tabSelectIndex == 1) {
      if (!this.tenantLoginForm.valid) {
        if (this.tenantLoginForm.controls.mobile.status === 'INVALID' ||
          this.tenantLoginForm.controls.password.status === 'INVALID') {
          this.error = '用户名或密码错误';
        } else if (this.tenantLoginForm.controls.smsCode.status === 'INVALID') {
          this.error = '请输入短信验证码';
        }
        return;
      }
      param = { loginType: 'SMS', mobile: this.tenantUser['mobile'], smsCode: this.tenantUser.smsCode }
    } else {
      if (!this.pwdLoginForm.valid) {
        if (this.pwdLoginForm.controls.mobile.status === 'INVALID' ||
          this.pwdLoginForm.controls.pwd.status === 'INVALID') {
          this.error = '用户名或密码错误';
        }
        return;
      }
      param = { loginType: "PWD", mobile: this.tenantUser['mobile'], pwd: CryptoJS.SHA256(this.tenantUser.pwd).toString() }
    }
    this.loading = true;
    this.error = undefined;

    this.authenticationService.tenantLogin(param)
      .subscribe(async result => {
        if(result.pwdEmpty){
          this.addPasswordModal = this.modalService.create({
            nzTitle:'为保证信息安全，请设置登录密码',
            nzContent:this.addUserPassword,
            nzFooter:this.addUserPasswordFooter
          })
        }
        console.log('user----------------',result)
        if (result.tenantList) {
          //改变登录状态
          this.store.dispatch(new UserActions.Login());
          this.tenantLoginResult = result;
          this.tenantList = result.tenantList;
          this.processTenantLogin();
          //保存
          // this.router.navigate(['/admin/parameters']);
        } else {
          this.error = '登录信息错误';
          this.loading = false;
        }
      }, err => {
        this.loading = false;
      });

  }
  //首次设置密码
  async handleAddPassword(){
    try {
      const result:any = await this.authenticationService.firstPwd({
        mobile:this.userPhone,
        newPwd:CryptoJS.SHA256(this.userPassword).toString()
      }).toPromise()
      // console.log(result)
      if(result.code === 0){
        this.notification.success('修改成功','')
        this.addPasswordModal.destroy()
      }
    }catch (e){
      console.log(e)
    }
  }
  //二维码扫码
  iframeSrc;
  showWxCode = false;
  showWx() {
    this.showWxCode = !this.showWxCode
    const url = environment.loginUrl ;
    const appid = 'wx8c73406e1e88fd1a' //'wx499352f10b9b9da2'
    let rUrl = encodeURIComponent(url);
    let state = '3d6be0a4035d839573b04816624a415e'
    // this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl( `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${rUrl}&response_type=code&scope=snsapi_login&state=${state}#wechat_redirect`)
    // var obj = new WxLogin({
    //   self_redirect: false,
    //   id: "iframe_panel2",
    //   appid: appid,
    //   scope: "snsapi_login",
    //   redirect_uri: rUrl,
    //   state: state,
    // });
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
    const wxElement = document.body.appendChild(s)
    wxElement.onload = function () {
      var obj = new window.WxLogin({
        self_redirect: false,
        id: "iframe_panel2",
        appid: appid,
        scope: "snsapi_login",
        redirect_uri: rUrl,
        state: state,
      });
    }
  }
  code
  ngAfterViewInit() {
    // const userFunctionJS: any = '../../../assets/scripts/wxLogin.js';
    // this.loadScript(userFunctionJS);
    // this.showWx()
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      try {
        this.code = params.get('code');
        if (this.code != undefined) {
          // console.log('code', this.code)
          let param: any = {};
          param = { loginType: "WECHAT_OPEN", wechatCode: this.code }
          this.loading = true;
          this.error = undefined;
          this.authenticationService.tenantLogin(param)
            .subscribe(async result => {
              if (result.tenantList) {
                //改变登录状态
                this.store.dispatch(new UserActions.Login());

                this.showWxCode = false
                this.tenantLoginResult = result;
                this.tenantList = result.tenantList;
                this.processTenantLogin()
                // this.router.navigate(['/admin/parameters']);

              } else {
                this.error = '登录信息错误';
                this.loading = false;
              }
            }, err => {
              this.loading = false;
            });

        } else {
          console.log('get没code')
        }

      } catch (e) {
        console.log('没有code')
      }

    });
  }
  // private loadScript(scriptUrl: string) {
  //   return new Promise((resolve, reject) => {
  //     console.log('loadScript:' + scriptUrl);
  //     const scriptElement = document.createElement('script');
  //     scriptElement.src = scriptUrl;
  //     scriptElement.onload = resolve;
  //     document.body.appendChild(scriptElement);
  //   });
  // }

  sendSmsCode() {
    if (this.tenantUser.mobile) {
      this.error = '';
      //正则校验
      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (!reg_tel.test(this.tenantUser.mobile)) {
        this.error = '请输入数字或11位数字';
        console.log(this.error)
        return false;
      }
      this.authenticationService.getSmsCode(this.tenantUser.mobile).subscribe(res => {
        if (res['code'] === 0) {
          this.setSmsColdDown()
        }
      })
    } else {
      this.error = '请输入合法的手机号码';
    }
  }

  setSmsColdDown() {
    if (window['setSmsColdDownInterval']) {
      this.hintMessage = '验证码已发送, 请在' + this.countDownNum + '秒后重试';
    } else {
      this.isSmsCodeSent = true;
      window['setSmsColdDownInterval'] = setInterval(() => {
        this.countDownNum -= 1;
        if (this.countDownNum === 0) {
          this.isSmsCodeSent = false;
          this.countDownNum = 60;
          clearInterval(window['setSmsColdDownInterval']);
        }
      }, 1000);
    }
  }

  processTenantLogin() {
    if (this.tenantList.length === 1) {
      this.loginCompany(this.tenantList[0]);
    } else {
      this.loading = false;
    }
  }

  loginCompany(tenant) {
    this.authenticationService.loginCompany(this.tenantLoginResult.accountLoginToken, tenant.tenantId)
      .subscribe(async user => {
        if (user) {
          const menu = await this.siteService.getDefaultLoginMenu()
          if (menu) {
            this.router.navigate([menu.menuUrl]);
          } else {
            this.notification.warning('没有访问页面的权限', '');
          }
        } else {
          this.error = '验证错误';
          this.loading = false;
        }
      }, err => {
        this.loading = false;
      });
  }

  clearTenantLogin() {
    this.tenantList = null;
    this.cookieService.delete('tenantLoginResult');
  }
  //判断当前用户的浏览器及操作系统
  checkCurrentBrowser(){
    let userAgent = navigator.userAgent.toLocaleLowerCase()
    console.log('userAgent-------',userAgent)
    let arr = userAgent.split(' ')
    var chromeVersion;
    for(var i=0;i < arr.length;i++){
      if(/chrome/i.test(arr[i]))
        chromeVersion = arr[i]
    }
    if(chromeVersion < 32) {
     this.isLowBrowserVersion = true
    }
    //此处搜狗浏览器隐藏了用户的ua对象，故无法判断
    //360浏览器ua对象会根据用户环境而改变，故无法准确判断是否360浏览器
    // this.browserTips = this.is360Chrome()
    //谷歌
    if(userAgent.includes('chrome')&&!userAgent.includes('qqbrowser')&&!userAgent.includes('edg')){
      this.browserTips = false
      //火狐
    }else this.browserTips = !userAgent.includes('firefox');
    //判断是否IE浏览器
    if (!!window.ActiveXObject || "ActiveXObject" in window){
      this.browserTips = true
    }
    //如果是低版本谷歌浏览器
    if(this.isLowBrowserVersion){
      this.browserTips = true
    }
    if(userAgent.includes('win')){
      this.isWindows = true
    }
    // console.log(this.browserTips)
  }
  //判断用户是否360浏览器，特殊处理
   is360Chrome = () => {
    const uas = navigator.userAgent.split(' ');
    let result = false;
    // 排除ua自带标志的双核浏览器, 余下chrome, chromium及360浏览器
    if (uas[uas.length - 1].includes('Safari')) {
      return result;
    }
    for (const key in navigator.plugins) {
      if (!Object.prototype.hasOwnProperty.call(navigator.plugins, key)) {
        continue;
      }
    // np-mswmp.dll文件在chromium及chrome未查询到
      if (navigator.plugins[key].filename === 'np-mswmp.dll') {
        result = true;
        return result;
      }
    }
  };
  //下载浏览器
  downloadBrowser(flag) {
    if(flag == 1){
      //去官网下载
      window.open('https://www.google.cn/chrome/')
    }else {
      //直接下载安装包
      if(this.isWindows){
        window.open('https://www.google.cn/chrome/')
      }else {
        window.open('https://www.google.cn/chrome/')
      }
    }
  }
}
